import { DefaultSuggestionsComponent } from "./components/suggestions/templates/default-suggestions/default-suggestions.component";
export const suggestionsComponentDef = {
    "suggestions": {
        "default": DefaultSuggestionsComponent,
        "social": DefaultSuggestionsComponent,
        "cielo": DefaultSuggestionsComponent
    }
}
